import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../config/firebase";
import { db } from "../config/firebase"
import { doc, setDoc, collection } from "firebase/firestore";

export default function Register({ navigation }) {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  function SignUp(e) {
    e.preventDefault();
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        const userDocRef = doc(db, "Users", user.uid);
        const studentCollectionRef = collection(userDocRef, "Students");
        const studentDocRef = doc(studentCollectionRef);
        const userAdd = setDoc(userDocRef, {
          name: firstName,
          email: email,
          phoneNumber: phoneNumber
        });

        const studentAdd = setDoc(studentDocRef, {
          name: firstName,
          email: email,
          phoneNumber: phoneNumber
        });

        return Promise.all([userAdd, studentAdd]);
      })
      .then(() => {
        navigate("/dashboard");
      })
      .catch((error) => {
        setError(error.message);
      });
  }

  return (
    <div>
      <form>
        <input
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        <input
          type="text"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder="Name"
        />
        <input
          type="text"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="Phone Number"
        />
        <button type="button" onClick={(e) => SignUp(e)}>
          Register
        </button>
      </form>
      {error && <p>{error}</p>}
    </div>
  );
}
